import optinConsentRDPlusThemeTemplate from '../../templates/dialog/RDPlusTheme/optin_consent_template.ejs'
import optinConsentTemplate from '../../templates/dialog/RDTheme/optin_consent_template.ejs'

const importOptinConsentTemplateFactory = (options = {}) => {
    if (ApexChat.IsRoundedDynamicPlusTheme) {
        return {
            optinConsentTemplate: optinConsentRDPlusThemeTemplate(options),
        }
    }
    return {
        optinConsentTemplate: optinConsentTemplate(options),
    };
};
export default importOptinConsentTemplateFactory;
